import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import css from './index.scss';
import SvgIcon from '../svg-icon/svg-icon';
import messages from './messages';

const ConfirmationMessage = props => (
    <div className={css.confirmationMessageContainer}>
        <div className={css.icon}>
            <SvgIcon icon={props.icon} />
        </div>
        <div className={css.success}>{props.title}</div>
        <div className={css.recordsMessage} >
            {props.children}
        </div>
        <button
            className={css.okButton}
            onClick={props.handleOnCloseModal}
        >{props.intl.formatMessage(messages.ok)}</button>
    </div>
);

ConfirmationMessage.propTypes = {
    handleOnCloseModal: PropTypes.func,
    icon: PropTypes.string,
    children: PropTypes.node,
    title: PropTypes.string,
    intl: intlShape.isRequired
};

export default injectIntl(ConfirmationMessage);



// WEBPACK FOOTER //
// ./app/components/confirmation-message/index.js